import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { tokens } from '../../theme';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(3),
        marginTop: theme.spacing(6),
        paddingTop: theme.spacing(4),
        borderTop: `1px solid ${tokens.border}`,
    },
    status: {
        color: tokens.inkSoft,
        fontSize: '0.9375rem',
        fontWeight: 600,
    },
}));

/**
 * Previous/next pager for client-side paginated lists. Renders nothing when
 * everything already fits on one page.
 */
export default function Pager({ page, totalPages, onChange }) {
    const classes = useStyles();
    if (totalPages <= 1) return null;

    return (
        <nav className={classes.root} aria-label="Pagination">
            <Button
                variant="outlined"
                startIcon={<NavigateBeforeIcon />}
                disabled={page <= 1}
                onClick={() => onChange(page - 1)}
            >
                Previous
            </Button>
            <span className={classes.status} aria-live="polite">
                Page {page} of {totalPages}
            </span>
            <Button
                variant="outlined"
                endIcon={<NavigateNextIcon />}
                disabled={page >= totalPages}
                onClick={() => onChange(page + 1)}
            >
                Next
            </Button>
        </nav>
    );
}
